
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import GoodsSwipe from '@/components/GoodsSwipe/index.vue'
import Rules from '@/views/goodsManage/commodity/template/commodsRules.vue'
import { GoodsInfoDto, getGoodsInfo, deleteGoods } from '@/api/commodity'
import { getGoodsSpecificationList, PackageListDto } from '@/api/buyCar'
import { isOptionalGoods } from '@/api/shoppingMall'
import { handleFill,imagePreview } from '@/utils/util'
import { goodsDetailDto, goodsPackageDto } from '@/api/goods'
import { confirm } from '@/utils/decorator'
import { shareToWeiXin } from '@/utils/h5ToApp'

@Component({
    name: 'CommodsDetail',
    components: {GoodsSwipe, Rules}
})
export default class commodsDetail extends Vue {
    @Getter companyId!: string
    handleFill = handleFill
    imagePreview = imagePreview
    // relationId=''
    params = {
        goodsId: '',
        companyId: '',
        packageId: '',
        shopId: '',
        customerId: ''
    }
    goodsInfo:
        | goodsDetailDto
        | { referPrice: string }
        | Record<string, any>
        | any = {
        goodsSpecificationList: []
    }
    packageList: PackageListDto[] = []
    onlyOnePackage = false // 判断是否只有一个套餐
    packageName = '' // 套餐名称
    packageWeight = '' // 套餐重量
    selectValueList: string[] = [] // 存储加购弹窗选中的规格，用于加购弹出窗设置默认选中的规格

    currGoodsPackage: goodsPackageDto = {}

    created () {
        this.params.goodsId = this.$route.query.goodsId as string
        this.getInfo()
        this.$eventBus.$on('currentPage', (data) => {
            this.changeCurrentPage(data)
        })
        // this.getPackageList()
    }

    // 用于控制物理按键返回问题  1:当前视图页面在添加编辑主页面  2:当前视图页面在商品分类弹框页面
    // 3:当前视图页面在商品品牌弹框页面 4:当前视图页面在商品标签弹框页面  5:当前视图页面在商品套餐弹框页面
    // 6:当前视图页面在商品套餐弹框页面的按客户级别设置页面中 7:当前视图页面在商品套餐弹框页面的按客户设置页面中

    currentPage = 1

    handleBack(){
      this.$router.replace('/commodity')
    }

    mounted () {
        // 注册原生调用h5返回事件
        this.handleAppBack()
    }

    changeCurrentPage (num) {
        this.currentPage = num
    }

    /**
     * 监听原生APP的返回事件
     */
    handleAppBack () {
        this.$bridge.registerHandler(
            'commodsDetailBack', () => {
                switch (this.currentPage) {
                    case 1:
                        this.$router.replace('/commodity')
                        break
                    case 6:
                        (this.$refs.Rules as any).handlPriceAppCancel()
                        break
                    case 7:
                        (this.$refs.Rules as any).handlPricesAppCancel()
                        break
                }
            }
        )
    }

    //获取商品详情信息
    getInfo () {
        getGoodsInfo(this.params).then((res) => {
            this.goodsInfo = res.data
            this.currGoodsPackage.marketPrice = this.goodsInfo.marketPrice
            this.currGoodsPackage.referPrice = this.goodsInfo.referPrice
        })
    }

    getSelectPackageInfo (info: PackageListDto, selectValueList: string[]) {
        // this.onlyOnePackage = true
        // this.packageName = info.packageNameDesc
        // this.packageWeight = info.weight
        // this.goodsInfo.orderPrice = info.orderPrice
        // this.selectValueList = selectValueList
    }

    getCurrGoodsPackage (data: goodsPackageDto) {
        this.currGoodsPackage = {
            marketPrice: this.goodsInfo.marketPrice,
            referPrice: this.goodsInfo.referPrice,
            ...data
        }
    }

    /**
     * 获取套餐列表
     * */
    getPackageList () {
        getGoodsSpecificationList(this.params).then((res) => {
            this.packageList = res.data.packageList || []
            if (this.packageList) {
                this.onlyOnePackage = this.packageList.length <= 1
                if (this.onlyOnePackage) {
                    this.packageWeight =
                        this.packageList[0] && this.packageList[0].weight
                    this.packageName =
                        this.packageList[0] && this.packageList[0].packageName
                }
            }
        })
    }

    //编辑
    toeditCommodity () {
        this.$router.push({
            path: '/addCommodity',
            query: {
                companyId: this.params.companyId,
                goodsId: this.params.goodsId,
                op: 'edit',
                // 是否下架
                upRighNow:this.$route.query.upRighNow
            }
        })
    }

    /**
     * 删除商品
     */
    @confirm('提示', '确定删除当前商品吗？')
    deleteGoods () {
        deleteGoods({
            goodsId: this.goodsInfo.goodsId
        }).then((res) => {
            this.$notify({
                type: 'success',
                message: '删除成功！'
            })
            window.sessionStorage.setItem("isRefresh", "1");
            this.$router.replace({
                path: '/commodity'
            })
        })
    }

    //   showRules() {
    //    (this.$refs.rules as any).show()
    // }
    /**
     * 打开选择规格弹窗
     * @param type ’1‘加入购物车  ’2‘立即下单  ’3‘选择规格可加购可下单
     */
    showRules () {
        (this.$refs.Rules as any).show({
            goodsInfo: this.goodsInfo,
            selectList: this.selectValueList
        })
    }

    /**
     * 调用原生方法分享
     */
    toShare () {
        const data = {
            title: this.goodsInfo.goodsName || '商品详情',
            description: '',
            url: `${window.location.origin}/shareGoodsDetail?goodsId=${this.params.goodsId}&shopId=${this.companyId}`
        }
        console.log(this.goodsInfo.goodsName || '商品详情')
        console.log(
            `${window.location.origin}/shareGoodsDetail?goodsId=${this.params.goodsId}&shopId=${this.companyId}`
        )
        shareToWeiXin(data)
    }
}
